var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeQrCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_3907",
    "data-name": "Group 3907",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26.489,
    height: 26.572,
    viewBox: "0 0 26.489 26.572",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_132",
    "data-name": "Rectangle 132",
    width: 26.489,
    height: 26.572,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_240",
    "data-name": "Group 240",
    transform: "translate(0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_346",
    "data-name": "Path 346",
    d: "M3.119,0A3.118,3.118,0,0,0,0,3.112v7.213H1.729V3.112a1.389,1.389,0,0,1,1.39-1.383H9.572V0Zm0,24.843a1.39,1.39,0,0,1-1.39-1.39V17.235H0v6.218a3.12,3.12,0,0,0,3.119,3.119H9.572V24.843Zm21.64-1.39a1.389,1.389,0,0,1-1.383,1.39H16.543v1.729h6.833a3.118,3.118,0,0,0,3.112-3.119V17.235H24.76ZM23.376,0H16.543V1.729h6.833A1.387,1.387,0,0,1,24.76,3.112v7.213h1.729V3.112A3.117,3.117,0,0,0,23.376,0",
    transform: "translate(0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_347",
    "data-name": "Path 347",
    d: "M14.151,15.22H9.586a1.212,1.212,0,0,1-1.21-1.21V9.629a1.212,1.212,0,0,1,1.21-1.21h4.565a1.212,1.212,0,0,1,1.21,1.21v4.38a1.212,1.212,0,0,1-1.21,1.21m-4.046-1.729h3.527V10.148H10.105Z",
    transform: "translate(-2.583 -2.596)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_348",
    "data-name": "Path 348",
    d: "M14,27.055H9.586a1.212,1.212,0,0,1-1.21-1.21V21.4a1.212,1.212,0,0,1,1.21-1.21H14a1.212,1.212,0,0,1,1.21,1.21v4.444A1.212,1.212,0,0,1,14,27.055m-3.9-1.729h3.381V21.92H10.105Z",
    transform: "translate(-2.583 -6.227)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_349",
    "data-name": "Path 349",
    d: "M25.844,15.06H21.625a1.212,1.212,0,0,1-1.21-1.21V9.629a1.212,1.212,0,0,1,1.21-1.21h4.219a1.212,1.212,0,0,1,1.21,1.21V13.85a1.212,1.212,0,0,1-1.21,1.21m-3.7-1.729h3.182V10.148H22.144Z",
    transform: "translate(-6.296 -2.596)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_350",
    "data-name": "Path 350",
    d: "M22.223,21.891a.95.95,0,1,1-.95-.95.95.95,0,0,1,.95.95",
    transform: "translate(-6.268 -6.458)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_351",
    "data-name": "Path 351",
    d: "M25.219,24.887a.95.95,0,1,1-.95-.95.95.95,0,0,1,.95.95",
    transform: "translate(-7.192 -7.382)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_352",
    "data-name": "Path 352",
    d: "M22.317,27.789a.95.95,0,1,1-.95-.95.95.95,0,0,1,.95.95",
    transform: "translate(-6.297 -8.277)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_353",
    "data-name": "Path 353",
    d: "M28.06,27.789a.95.95,0,1,1-.95-.95.95.95,0,0,1,.95.95",
    transform: "translate(-8.068 -8.277)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_354",
    "data-name": "Path 354",
    d: "M28.06,21.86a.95.95,0,1,1-.95-.95.95.95,0,0,1,.95.95",
    transform: "translate(-8.068 -6.448)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeQrCode);
export default __webpack_public_path__ + "static/media/home-qr-code.02a3a1643e6a5ea942d6194d5cc42f35.svg";
export { ForwardRef as ReactComponent };